import { PipeTransform, Pipe } from '@angular/core';
import { formatDate } from '@angular/common';
import { DIMBO_CONSTANT } from './../utils/constant';
import moment from 'moment';

// Define a pipe for date format
@Pipe({ name: 'date' })
export class DatePipe implements PipeTransform {

    // Transform method to handle the pipe execution
    transform(date: string ): string {
        var formattedDate =  moment(new Date(date)).format('DD-MM-YYYY');
    
        return formattedDate;
    }
}